/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import CustomDataGrid from "../../Shared/Table/CustomDataGrid";
import { useDeviceConfigTemplateDisplay } from "./hooks";
import { GridSortModel, GridToolbarContainer } from "@mui/x-data-grid";
import { prepareCommTemplateCellDataGrid, prepareGlobalTemplatesDataGrid, prepareLocalTemplateCellDataGrid } from "../../../pages/Configuration/helpers";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { useSelector } from "react-redux";
import { selectedDeviceSelector, selectedTypeSelector } from "../../../store/api/devices/selectors";
import { getSortBy } from "../../../utils/helpers";

interface IProps {
  templateType: string;
}

const LocalTemplates: React.FC<IProps> = ({ templateType }) => {
  const { data = [], isLoading, TemplateColumns, setSortOrderToLocalTemplate } = useDeviceConfigTemplateDisplay();
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const selectedTempType = useSelector(selectedTypeSelector);
  const rowsData = prepareLocalTemplateCellDataGrid(data, selectedDevice?.objectKey || "") || [];
  const globalRowsData = prepareCommTemplateCellDataGrid(data, selectedDevice?.objectKey || "") || [];
  const globalTemplates = prepareGlobalTemplatesDataGrid(globalRowsData) || []

  const DataGridTitle = () => {
    return (
      <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
        <div className="text-sm">{`Showing ${selectedTempType === "global" ? globalTemplates?.length : rowsData?.length} results`}</div>
      </GridToolbarContainer>
    )
  }
  return (
    <div className="w-full">
      <CustomDataGrid
        tableId="localTemplate"
        sx={{ height: "420px" }}
        rows={selectedTempType === "global" ? globalTemplates : rowsData}
        columns={TemplateColumns}
        rowCount={selectedTempType === "global" ? globalTemplates?.length : rowsData?.length}
        loading={isLoading}
        disableColumnMenu={true}
        //getRowId={(row: ITemplates) => row.id}
        // onRowClick={handleRowClicked}
        slots={{ toolbar: DataGridTitle }}
        hideFooter={true}
        onSortModelChange={(params: GridSortModel) => setSortOrderToLocalTemplate(getSortBy(params))}
      />
    </div>
  );
};

export default LocalTemplates;
